import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	margin-top: 10px;
	display: flex;
	flex-direction: column;
	gap: 5px;
	align-items: center;
	justify-content: center;
`;

export const Container = styled.div`
	display: flex;
	padding: 8px 9px;
	flex-direction: column;
	gap: 6px;
	border-radius: 8px;
	background: #f4f6f8;
	color: #29185e;
	font-family: 'Lato';
	text-align: left;
	line-height: 100%;
	letter-spacing: 0.28px;
	width: 100%;
	max-width: 500px;
	box-sizing: border-box;
`;

export const TopTextSection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const SceneName = styled.div`
	font-weight: 700;
	font-size: 16px;
`;

export const SceneDescription = styled.div`
	font-weight: 400;
	font-size: 14px;
`;

export const BottomWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	width: 100%;
`;

export const Line = styled.div`
	width: 30%;
	height: 2px;
	background-color: #eef2f5;
	@media (min-width: 600px) {
		width: 40%;
	}
`;

export const GrayText = styled.div`
	font-family: 'Work Sans';
	color: #8477af;
	font-size: 10px;
	white-space: nowrap;
`;

export const ReportButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-right: 2px;
	padding-bottom: 2px;
`;

export const ReportButton = styled.img`
	display: flex;
	justify-self: flex-end;
	width: 14px;
`;
